module.exports = __webpack_public_path__ + "img/Clean  building rubble.4e68a7f3.svg";